import { ComponentType } from '../schematics/components/schema';

export type SchematicsFolder = ComponentType;
